import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgCamera = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 5a1 1 0 00-1 1v1H4a1 1 0 00-1 1v10a1 1 0 001 1h16a1 1 0 001-1V8a1 1 0 00-1-1h-4V6a1 1 0 00-1-1H9zM5 8.75A.75.75 0 015.75 8h.5a.75.75 0 010 1.5h-.5A.75.75 0 015 8.75zM12 17a4 4 0 100-8 4 4 0 000 8zm1.774-2.239c-.466.47-1.1.739-1.774.739a.5.5 0 010-1 1.496 1.496 0 001.5-1.5.5.5 0 011 0c0 .668-.264 1.296-.726 1.761z"
      clipRule="evenodd"
    />
  </svg>
));
SvgCamera.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgCamera;
